<template>
  <div class="main fc ac">
    <van-cell-group style="margin-top:110px">
      <van-cell
        title="工作简介"
        @click="to('http://hszh.baoshan.sh.cn/hszh060/hszh061/201705/t20170521_218095.html')"
      />
      <van-cell
        title="服务内容"
        @click="to('http://hszh.baoshan.sh.cn/hszh040/hszh042/201705/t20170521_218062.html')"
      />
      <van-cell title="社区站点" @click="to('http://hszh.baoshan.sh.cn/hszh040/hszh043/')" />
      <van-cell title="志愿服务报名" @click="go('/volunteer/apply')" />
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: "home",

  data() {
    return {
      submit_form: {
        contribute_type: 3,
        contribute_name: "志愿者服务",
        name: "",
        mobile: "",
        address: "请选择"
      },
      apply_sucess: false,
      address_show: false,
      address_list: [
        "请选择",
        "吴淞街道",
        "友谊路街道",
        "罗店镇",
        "大场镇",
        "杨行镇",
        "月浦镇",
        "罗泾镇",
        "顾村镇",
        "高境镇",
        "庙行镇",
        "淞南镇",
        "宝山工业区",
        "城市工业园区"
      ]
    };
  },

  methods: {
    to(url) {
      location.href = url;
    },
    //提交
    submit() {
      if (!this.submit_form.name) {
        Toast("请输入名字");
        return;
      }

      if (!this.submit_form.name) {
        Toast("请输入手机号");
        return;
      }

      if (this.submit_form.name == "请选择") {
        Toast("请选择地址");
        return;
      }
      this.post("contribute/add", this.submit_form).then(res => {
        this.apply_sucess = true;
      });
    },
    toZxgxb() {
      this.$router.push({
        path: "zxgxb"
      });
    },
    toJxxz() {
      this.$router.push({
        path: "jxxz"
      });
    },
    toCjd() {
      this.$router.push({
        path: "cjd"
      });
    },
    toJxlc() {
      this.$router.push({
        path: "jxlc"
      });
    },
    //确认地址
    confirmAddress(item) {
      this.submit_form.address = item;
      this.address_show = false;
    },
    toSignUp() {
      window.open("http://np-culture.org/event/sh-blood/redcross/");
    }
  },
  components: {},
  mounted() {}
};
</script>


<style lang="less" scoped>
.main {
  box-sizing: border-box;
  // padding: 44px;
  width: 100vw;
  min-height: 100vh;
  // height: 100vh;

  background-image: url("./../../assets/volunteer/home/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: #fffafa;
}
.active {
  background-color: #fb5358;
  color: white;
}
.black {
  color: black;
}
/deep/ .van-collapse-item__content {
  color: black;
}

/deep/ .van-collapse-item__content {
  color: black;
}
/deep/ .van-collapse-item__content {
  background-color: #fffafa;
}
.red {
  font-weight: bold;
  color: #fb5363;
}
/deep/.van-cell__title {
  font-weight: bold;
}

/deep/ .van-tabs {
  width: 100%;
}
/deep/.van-tabs__nav--card {
  margin: 0;
}
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 98px;
}
/deep/.van-cell-group {
  width: 100%;
}
/deep/ .van-cell__title {
  color: #fb5358;
  font-weight: bold;
}
</style>